import React, { useRef, useState, useEffect } from 'react'
import { Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import * as sxStyles from '../../dialogs/dialogs.style'

interface IHelperTextWithTooltipProps {
  text: string
  isRight: boolean
  isWarning: boolean
}

const HelperTextWithTooltip: React.FC<IHelperTextWithTooltipProps> = ({
  text,
  isRight,
  isWarning,
}) => {
  const textRef = useRef(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xl'))
  const isXSmallScreen = useMediaQuery('(max-width:1100px)')
  const isXXSmallScreen = useMediaQuery('(max-width:750px)')

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(
        textRef.current.scrollHeight > textRef.current.clientHeight
      )
    }
  }, [text])

  return (
    <Tooltip title={isOverflowing ? text : ''} arrow>
      <Typography
        ref={textRef}
        component="span"
        sx={{
          ...(isRight
            ? isXXSmallScreen
              ? sxStyles.smallScreenRightHelperTextStyle
              : isXSmallScreen
                ? sxStyles.XSmallScreenRightHelperTextStyle
                : isSmallScreen
                  ? sxStyles.sRightHelperTextStyle
                  : sxStyles.rightHelperTextStyle
            : isXXSmallScreen
              ? sxStyles.leftSmallScreenHelperTextStyle
              : isXSmallScreen
                ? sxStyles.leftHelperTextStyle
                : sxStyles.leftSmallScreenHelperTextStyle),
          ...(isWarning && sxStyles.warningColor),
        }}
      >
        {text}
      </Typography>
    </Tooltip>
  )
}

export default HelperTextWithTooltip
